
import "./internal.css";

import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, query } from "firebase/firestore";

/* navegação */
import { useNavigate } from "react-router-dom";

export default function Internal() {

    const navigate = useNavigate();

    const [dnew, setDnew] = useState({i1: 0, i2: 0, i3: 0, i4: 0, i5: 0, i6: 0, i7: 0, i8: 0, i9: 0});

    useEffect(() => {
        async function loadresume() {

            let tn1 = 0;
            let tn2 = 0;
            let tn3 = 0;
            let tn4 = 0;
            let tn5 = 0;
            let tn6 = 0;
            let tn7 = 0;
            let tn8 = 0;
            let tn9 = 0;

            const clientsdb = collection(db, "clients");
            const clientsquery = query(clientsdb);
                
            await getDocs(clientsquery)
            .then((value) => {

                value.forEach((doc) => {
                    tn2++;
                })
                
            })
            .catch((error) => {

            })

            const agentsdb = collection(db, "agents");
            const agentsquery = query(agentsdb);
                
            await getDocs(agentsquery)
            .then((value) => {

                value.forEach((doc) => {
                    switch(doc.data().status) {
                        case 1: 
                            tn3++;
                            break;
                        case 2: 
                            tn4++;
                            break;
                        case 3: 
                            tn5++;
                            break;
                        case 4: 
                            tn6++;
                            break;
                        case 5: 
                            tn7++;
                            break;
                        case 6: 
                            tn8++;
                            break;
                        default:
                            tn9++;
                    }
                })
                
            })
            .catch((error) => {

            })
            
            setDnew({i1: "-", i2: tn2, i3: tn3, i4: tn4, i5: tn5, i6: tn6, i7: tn7, i8: tn8, i9: tn9});
                
        }

        loadresume();

        return () => {}

    }, [])


    function details(id) {
        navigate(`/details/${id}`);
    }
    

    return(
        <div className="internal_context">
            <span className="internal_title">WINNERS.AI</span>
            <span className="internal_topic">Fluxo de Operações - Posição atual do cliente</span>

            <div className="internal_resume">

                <div className="internal_resume_line">
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_arrow">
                        <div className="internal_resume_arrow1"></div>
                        <div className="internal_resume_arrow2">
                            <div className="internal_resume_arrow2a"></div>
                            <div className="internal_resume_arrow2b" style={{borderTop: "dashed 2px gray", borderLeft: "dashed 2px gray"}}></div>
                        </div>
                    </div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "green"}}>Ag. Ativos</span>
                            <span className="internal_resume_number">{ dnew.i6 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_arrow">
                        <div className="internal_resume_arrow2">
                            <div className="internal_resume_arrow2a"></div>
                            <div className="internal_resume_arrow2b" style={{borderTop: "dashed 2px gray", borderRight: "dashed 2px gray"}}></div>
                        </div>
                        <div className="internal_resume_arrow1"></div>
                    </div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_desativados">
                        <span className="internal_resume_desativados_title" style={{color: "brown"}}>Desativados Cliente</span>
                        <span className="internal_resume_desativados_number">{ dnew.i7 }</span>
                    </div>
                </div>

                <div className="internal_resume_line">
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "black"}}>Leads</span>
                            <span className="internal_resume_number">{ dnew.i1 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_space">
                        <div className="internal_resume_next"></div>
                    </div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "blue"}}>Cadastros</span>
                            <span className="internal_resume_number">{ dnew.i2 - (dnew.i3 + dnew.i4 + dnew.i5 + dnew.i6 + dnew.i7 + dnew.i8 + dnew.i9) }</span>
                        </div>
                    </div>
                    <div className="internal_resume_space">
                        <div className="internal_resume_next"></div>
                    </div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "blue"}}>Ag. Criados</span>
                            <span className="internal_resume_number">{ dnew.i3 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_space">
                        <div className="internal_resume_next"></div>
                    </div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "blue"}}>Ag. Config.</span>
                            <span className="internal_resume_number">{ dnew.i4 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "brown"}}>Ag. Desativ.</span>
                            <span className="internal_resume_number">{ dnew.i7 + dnew.i8 + dnew.i9 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_space">
                        <div className="internal_resume_next"></div>
                    </div>
                    <div className="internal_resume_desativados">
                        <span className="internal_resume_desativados_title" style={{color: "brown"}}>Desativados Pagamento</span>
                        <span className="internal_resume_desativados_number">{ dnew.i8 }</span>
                    </div>
                </div>

                <div className="internal_resume_line">
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_box"></div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_arrow">
                        <div className="internal_resume_arrow1"></div>
                        <div className="internal_resume_arrow2">
                            <div className="internal_resume_arrow2a" style={{borderBottom: "dashed 2px gray", borderLeft: "dashed 2px gray"}}></div>
                            <div className="internal_resume_arrow2b"></div>
                        </div>
                    </div>
                    <div className="internal_resume_box">
                        <div className="internal_resume_frame">
                            <span className="internal_resume_title" style={{color: "red"}}>Ag. Erros</span>
                            <span className="internal_resume_number">{ dnew.i5 }</span>
                        </div>
                    </div>
                    <div className="internal_resume_arrow">
                        <div className="internal_resume_arrow2">
                            <div className="internal_resume_arrow2a" style={{borderBottom: "dashed 2px gray", borderRight: "dashed 2px gray"}}></div>
                            <div className="internal_resume_arrow2b"></div>
                        </div>
                        <div className="internal_resume_arrow1"></div>
                    </div>
                    <div className="internal_resume_space"></div>
                    <div className="internal_resume_desativados">
                        <span className="internal_resume_desativados_title" style={{color: "brown"}}>Desativados Interno</span>
                        <span className="internal_resume_desativados_number">{ dnew.i9 }</span>
                    </div>
                </div>

            </div>

            <div className="internal_legends">
                <span className="internal_legends_title">Legendas:</span>
                <span className="internal_legends_item"><span style={{color: "black"}}>Leads</span>&nbsp;= Número de clientes que acessaram a plataforma.</span>
                <span className="internal_legends_item"><span style={{color: "blue"}}>Cadastros</span>&nbsp;= Número de clientes que realizaram o cadastro na plataforma, não criaram e nem configuraram agente.</span>
                <span className="internal_legends_item"><span style={{color: "blue"}}>Ag. Criados</span>&nbsp;= Agentes que foram criados mas não foram configurados.</span>
                <span className="internal_legends_item"><span style={{color: "blue"}}>Ag. Config.</span>&nbsp;= Agentes criados e configurados e estão pendentes de serem ativados. Pendentes da ativação da Winners.</span>
                <span className="internal_legends_item"><span style={{color: "red"}}>Ag. Erros</span>&nbsp;= Agentes que tentaram ser ativados mas estão em stand by por algum problema técnico, poderão ser ativados ou desativados pela Winners.</span>
                <span className="internal_legends_item"><span style={{color: "green"}}>Ag. Ativos</span>&nbsp;= Agentes que conseguiram ser ativados e estão em pleno funcionamento.</span>
                <span className="internal_legends_item"><span style={{color: "brown"}}>Ag. Desativ.</span>&nbsp;= Total de agentes que foram desativados, conforme motivos abaixo.</span>
                <span className="internal_legends_item"><span style={{color: "brown"}}>Desativados Cliente</span>&nbsp;= Agentes que foram desativados pelo próprio cliente.</span>
                <span className="internal_legends_item"><span style={{color: "brown"}}>Desativados Pagamento</span>&nbsp;= Agentes que foram desativados por falta de pagamento do cliente, após respeitar todos os períodos na régua de cobrança.</span>
                <span className="internal_legends_item"><span style={{color: "brown"}}>Desativados Interno</span>&nbsp;= Agentes que foram desativados pela Winners por causas técnicas que não foram solucionadas.</span>
            </div>

            <span className="space_form"></span>
            <span className="space_form"></span>

            <span className="internal_topic">Fluxo de Operações - Funil das jornadas</span>

            <div className="internal_funnel">
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "black"}}>Leads</span>
                        <span className="internal_funnel_number">0 (0%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        {/* <span className="inernal_funnel_level" style={{height: "0%"}}></span> */}
                    </div>
                </div>
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "blue"}}>Cadastros</span>
                        <span className="internal_funnel_number">{dnew.i2} (T 100%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        <span className="inernal_funnel_level" style={{height: "100%"}}></span>
                    </div>
                </div>
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "blue"}}>Ag. Criados</span>
                        <span className="internal_funnel_number">{dnew.i2} (T 100%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        <span className="inernal_funnel_level" style={{height: "100%"}}></span>
                    </div>
                </div>
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "blue"}}>Ag. Config.</span>
                        <span className="internal_funnel_number">{dnew.i2} (T 100%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        <span className="inernal_funnel_level" style={{height: "100%"}}></span>
                    </div>
                </div>
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "green"}}>Ag. Ativos / Erro</span>
                        <span className="internal_funnel_number">{dnew.i2} (T 100%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        <span className="inernal_funnel_level" style={{height: "100%"}}></span>
                    </div>
                </div>
                <div className="internal_funnel_box">
                    <div className="internal_funnel_box_top">
                        <span className="internal_funnel_title" style={{color: "brown"}}>Ag. Desativ.</span>
                        <span className="internal_funnel_number">{dnew.i7 + dnew.i8 + dnew.i9} (T 100% - Q 0%)</span>
                    </div>
                    <div className="internal_funnel_box_body">
                        <span className="inernal_funnel_level" style={{height: "100%"}}></span>
                    </div>
                </div>

            </div>

           
            


            <span className="space_form"></span>
            <span className="space_form"></span>
            <span className="space_form"></span>

        </div>
    )
}